import { createContext } from 'react';
import { userApi } from '../api';
import { ContextValues, SessionStatus } from './Session.types';
import { UserRolesEnum } from '@shared';
import { RouteEnum } from 'App/routes';

export const initialUser = {
  partnerUUIDs: [''],
  roles: {
    isAuditor: false,
    isInstructor: false,
    isLeadAuditor: false,
  },
};

export const SessionContext = createContext<ContextValues>({
  initializing: true,
  authenticated: false,
  unauthenticated: false,
  unauthenticate: (doNavigate?: boolean) => doNavigate,
  login: () => null,
  verification: () => null,
  logout: () => null,
  currentUser: initialUser,
  initialPage: { pathname: RouteEnum.Login },
  isCredsEntered: false,
  status: SessionStatus.Initializing,
});

export const currentUserSelector = ({ partnerUUIDs, roles, verified }: userApi.UserAPI) => ({
  partnerUUIDs,
  roles: {
    isAuditor: roles.includes(UserRolesEnum.auditor),
    isLeadAuditor: roles.includes(UserRolesEnum.leadAuditor),
    isInstructor: roles.includes(UserRolesEnum.instructor),
  },
  verified,
});
